import { createTheme } from "@mui/material/styles"

export const theme = createTheme({
  palette: {
    primary: {
      main: "#006fc0",
      light: "#2A79E2",
    },
    secondary: {
      main: "#F28C28",
    },
    success: {
      main: "#28A745",
    },
    text: {
      primary: "#003366",
      secondary: "#333",
    },
    background: {
      default: "#FFFFFF",
      paper: "#F4F7F9",
    },
  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
    h1: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 900,
      fontSize: "3.2rem",
      lineHeight: 1.2,
      color: "#003366",
    },
    h2: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 900,
      fontSize: "2.5rem",
      lineHeight: 1.2,
      color: "#003366",
    },
    h3: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 900,
      fontSize: "1.5rem",
      lineHeight: 1.2,
      color: "#003366",
    },
    h4: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 600,
      fontSize: "1.2rem",
      color: "#003366",
    },
    body1: {
      lineHeight: 1.7,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 5,
          padding: "12px 28px",
          fontWeight: 600,
          textTransform: "none",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "translateY(-3px)",
          },
        },
      },
    },
  },
})
